<template>
    <div>
        <banner type="5"></banner>
        <router-view />

    </div>
</template>

<script>
    export default {
        name: 'informationCenter',
        props: {
            msg: String
        },
        data() {
            return {}
        },
        mounted() {
        },
        methods: {

        },

    }
</script>
<style scoped lang="scss">
    .nav {
        height: 100px;
        width: 100%

    }
</style>
